export default __webpack_public_path__ + "static/media/down.8a8d47a3.svg";